/* eslint-disable camelcase */
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

import { RangeSelectorType } from 'modules/api/const';

import { currentEnv } from '../common';
import { getConfig } from '../stake';

export const AXIOS_DEFAULT_CONFIG: AxiosRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
};

export interface IGetStatsResponse {
  ratio: number;
  tvl: string;
  apy: number;
  stakers: number;
  epoch_started_at: number;
  iota_price: number;
  boosted_apy: number;
  total_rewards: string;
}

export type IGetStakingChartDataResponse = {
  tvl: string;
  timestamp: number;
}[];

export type IGetRatioChartDataResponse = {
  ratio: string;
  timestamp: number;
}[];

export class AnalyticsApi {
  private static instance?: AnalyticsApi;

  public api: AxiosInstance;

  private constructor() {
    AnalyticsApi.instance = this;

    this.api = axios.create({
      ...AXIOS_DEFAULT_CONFIG,
      baseURL: getConfig(currentEnv).api,
    });
  }

  public static getInstance(): AnalyticsApi {
    if (AnalyticsApi.instance) {
      return AnalyticsApi.instance;
    }

    return new AnalyticsApi();
  }

  async getStats(): Promise<IGetStatsResponse> {
    const { data } = await this.api.get(`/v1/stats`);

    return data;
  }

  async getStakingChartData(
    period: RangeSelectorType,
  ): Promise<IGetStakingChartDataResponse> {
    const { data } = await this.api.get(`/v1/tvls?period=${period}`);

    return data;
  }

  async getRatioChartData(
    period: RangeSelectorType,
  ): Promise<IGetRatioChartDataResponse> {
    const { data } = await this.api.get(`/v1/ratios?period=${period}`);

    return data;
  }
}
